module.exports = __webpack_public_path__ + "img/pharmaceutical.695053f9.jpg";